import { Serviceability, FileType, LogisticNetwork } from '@/types/data';
import { useNetworks } from '@/hooks/useNetworks';
import { useFileData } from '@/hooks/useFileData';

export const useServiceabilityData = (currentNetwork: LogisticNetwork | null) => {
  const { getEditedServiceability, autosaveServiceability } = useNetworks();

  // Create empty row configuration
  const createEmptyRow = (): Serviceability => ({
    courier: '',
    dropoff: 'n',
    pickup: 'n',
    suburb: '',
    postcode: '',
    state: '',
    dropoff_zone: '',
    pickup_zone: '',
  });

  // Use the generic file data hook
  const {
    data: serviceability,
    isEdited,
    isSaving,
    addEmptyRow,
    discardChanges,
    handleRowsChange,
    deleteRow,
  } = useFileData<Serviceability>(currentNetwork, {
    fileType: FileType.Serviceability,
    getEditedData: getEditedServiceability,
    autosaveData: autosaveServiceability,
    createEmptyRow,
  });

  return {
    serviceability,
    isEdited,
    isSaving,
    addEmptyRow,
    discardChanges,
    handleRowsChange,
    deleteRow,
  };
};
